import { Container, Box, Grid, Typography, CircularProgress, Alert, Grid2, Button } from "@mui/material";
import React, { useState, useEffect } from "react";
import ProjectCard from "../components/ProjectCard";
import { ApiHelper } from "../utils/apiHelper";
import { useDispatch } from "react-redux";
import { createStartup } from "../store/startup/startupSlice";

export default function MyCampaigns() {
    const [campaigns, setCampaigns] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    const dispatch = useDispatch();

    const fetchCampaigns = async () => {
        try {
            setLoading(true);
            const response = await ApiHelper.get("/startup");
            if (response.data.code === "00000") {
                setCampaigns(response.data.response);
            }
            console.log(response.data.response)
        } catch (error) {
            setError("Kampanyalar yüklenirken bir hata oluştu.");
            console.error("Error fetching campaigns:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchCampaigns();
    }, []);

    const handleNewCampaign = async () => {
        await dispatch(createStartup());
        fetchCampaigns();
    }

    if (loading) {
        return (
            <Container maxWidth="lg">
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '60vh' }}>
                    <CircularProgress />
                </Box>
            </Container>
        );
    }

    return (
        <Container maxWidth="lg">
            <Box sx={{ py: 4 }}>
                <Grid2 item size={{xs: 12, md: 6}} display="flex" justifyContent="space-between" alignItems="center">
                    <Typography variant="h4" gutterBottom>
                        Kampanyalarım
                    </Typography>
                    <Button variant="contained" color="primary" onClick={handleNewCampaign}>
                        Yeni Kampanya Oluştur
                    </Button>
                </Grid2>

                {error && (
                    <Alert severity="error" sx={{ mb: 3 }}>
                        {error}
                    </Alert>
                )}

                {campaigns.length === 0 ? (
                    <Alert severity="info">
                        Henüz kampanya bulunmuyor.
                    </Alert>
                ) : (
                    <Grid container spacing={4}>
                        {campaigns.map((campaign) => (
                            <Grid item xs={12} sm={6} key={campaign.startupId}>
                                <ProjectCard
                                    startupId={campaign.startupId}
                                    logoSrc={campaign.profile.mainLogoPath || "/img/default-logo.png"}
                                    projectSrc="/img/project.jpeg"
                                    title={campaign.profile.name || "İsimsiz Kampanya"}
                                    description={campaign.profile.shortDescription || "Açıklama bulunmuyor"}
                                    fundedAmount={0}
                                    targetAmount={0}
                                    investors={0}
                                    highestInvestment={0}
                                    campaignEndDate="Belirlenmedi"
                                    status={campaign.status}
                                    isOwner={true}
                                />
                            </Grid>
                        ))}
                    </Grid>
                )}
            </Box>
        </Container>
    );
}